if (!customElements.get('vieux-benefits-navigation')) {
  customElements.define('vieux-benefits-navigation', class extends HTMLElement {
    connectedCallback() {
      const grid = document.getElementById(this.dataset.target)?.querySelector('.multicolumn');
      if (!grid) return;
      const items = [...grid.children].filter(item => item.classList.contains('grid-item'));
      if (!items.length) return;
      let frame = 0;
      let visibleCount = 0;
      let targets = [];
      let buttons = [];
      const update = () => {
        const itemWidth = items[0].getBoundingClientRect().width;
        if (!itemWidth || !grid.clientWidth) return;
        const visible = Math.max(1, Math.min(items.length, Math.round(grid.clientWidth / itemWidth)));
        const pages = Math.ceil(items.length / visible);
        const maxScroll = Math.max(0, grid.scrollWidth - grid.clientWidth);
        targets = Array.from({ length: pages }, (_, page) =>
          Math.min(page * visible * itemWidth, maxScroll));
        if (visible !== visibleCount) {
          visibleCount = visible;
          this.replaceChildren();
          buttons = targets.map((target, page) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.addEventListener('click', () => {
              const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
              grid.scrollTo({ left: targets[page], behavior: reduced ? 'instant' : 'smooth' });
            });
            this.append(button);
            return button;
          });
        }
        let active = 0;
        targets.forEach((target, page) => {
          if (Math.abs(grid.scrollLeft - target) < Math.abs(grid.scrollLeft - targets[active])) active = page;
          const first = Math.round(target / itemWidth) + 1;
          const last = Math.min(first + visible - 1, items.length);
          buttons[page].setAttribute('aria-label', 'Ver benefícios ' + first + ' a ' + last);
        });
        buttons.forEach((button, page) => button.setAttribute('aria-current', String(page === active)));
      };
      const onScroll = () => {
        if (frame) return;
        frame = requestAnimationFrame(() => { frame = 0; update(); });
      };
      grid.addEventListener('scroll', onScroll, { passive: true });
      const observer = new ResizeObserver(update);
      observer.observe(grid);
      update();
      this.cleanup = () => {
        grid.removeEventListener('scroll', onScroll);
        observer.disconnect();
        cancelAnimationFrame(frame);
      };
    }
    disconnectedCallback() { this.cleanup?.(); }
  });
}
